import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import API from '../../utils/Api';

const ForgetPassword = () => {
  const [form] = Form.useForm();
  const myApi = new API({});
  myApi.createEntity({ name: 'user' });

  const onFinish = (values) => {
    const email = values;
    myApi.endpoints.user.send(email, {}, 'reset').then((res) => {
      if (res.data === "Email id doesn't exist")
        notification.error({ message: res.data });
      else {
        notification.success({ message: res.data });
      }
    });
  };

  return (
    <div className='error-container'>
      <div>
        <div className='text-center'>
        </div>
        <h2>Password Reset</h2>
        <p>
          Please provide your account’s email and we will send you a reset
          password link
        </p>
        <Form form={form} layout='vertical' onFinish={onFinish}>
          <Form.Item
            name='email'
            rules={[
              {
                required: true,
                message: 'Please enter user email!',
              },
            ]}
          >
            <Input placeholder='User email' />
          </Form.Item>
          <Form.Item style={{ 'margin-bottom': 0 }}>
            <Button htmlType='submit' type='primary'>
              Send Mail
            </Button>
          </Form.Item>
        </Form>
        <p>
          <Link to='/'>Login?</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgetPassword;
